export default __webpack_public_path__ + "static/media/qwiklabs-logo.053940de.png";